export default __webpack_public_path__ + "static/media/Erik-foto.1239d8ec.png";